import React, { useEffect, useRef, useState } from "react";
import * as cornerstone from "cornerstone-core";
import * as cornerstoneMath from "cornerstone-math";
import * as cornerstoneTools from "cornerstone-tools";
import Hammer from "hammerjs";
import * as cornerstoneWebImageLoader from "cornerstone-web-image-loader";
import * as cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader';
import * as cornerstoneFileImageLoader from 'cornerstone-file-image-loader';
import Xarrow from 'react-xarrows';

import * as dicomParser from "dicom-parser";
import withSnackbar from '../../common/hook/useNotification';
import { getImage, base64ToBuffer } from '../../../service/api.service'
import { AntSwitch, mapCoordinate, PrettoSlider } from "../../common/codeHelper";
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';



cornerstoneTools.external.cornerstone = cornerstone;
cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
cornerstoneWebImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
cornerstoneFileImageLoader.external.cornerstone = cornerstone;
cornerstoneTools.external.Hammer = Hammer;




// const coordinatesBoudries = [
//     [
//         145,
//         210,
//         177,
//         279
//     ],
//     [
//         207,
//         187,
//         239,
//         261
//     ],
//     [
//         278,
//         178,
//         308,
//         250
//     ],
//     [
//         339,
//         185,
//         388,
//         255
//     ],
//     [
//         387,
//         228,
//         435,
//         277
//     ]
// ];

let state = {
    imageIds: '',
    sliceData: '',
    coordinate: '',
    currentImageIndex: 0,
    boneName: '',
    offsetPixel: { x: 0, y: 0 },
    offsetFractionY: 0,
    offsetFractionX: 0,
    imageLoaded: false,
};



let reportViewElement, ReportViewerElementDiv;
let imageLoaded = false;
function ReportView(props) {

    const boxL3 = { id: 'boxL3', ref: useRef(null) };
    const boxL4 = { id: 'boxL4', ref: useRef(null) };
    const boxL5 = { id: 'boxL5', ref: useRef(null) };
    const boxL3Parent = { id: 'boxL3Parent', ref: useRef(null) };
    const boxL4Parent = { id: 'boxL4Parent', ref: useRef(null) };
    const boxL5Parent = { id: 'boxL5Parent', ref: useRef(null) };

    const [showOriginal, setShowOriginal] = React.useState(true);
    const [imageLoadedBool, setImageLoadedBool] = React.useState(state.imageLoaded);
    const [analysis, setAnalysis] = React.useState(state.imageLoaded);
    const [viewStyle, setViewStyle] = React.useState({ height: '10px', width: '10px' });
    let [diskWisePredictions, setDiskWisePredictions] = useState([]);
    const [currentIndex, setCurrentIndex] = useState();
    const [lineStyle, setLineStyle] = React.useState({
        top: 223,
        visibility: 'hidden',
        height: '5px',
        hovered: false
    });

    const [lineStyleL4, setLineStyleL4] = React.useState({
        top: 276,
        visibility: 'hidden',
        height: '5px',
        hovered: false
    });

    const [lineStyleL5, setLineStyleL5] = React.useState({
        top: 314,
        visibility: 'hidden',
        height: '5px',
        hovered: false
    });


    state = {
        imageIds: '',
        sliceData: props.sliceData.reportImageData,
        currentImageIndex: state.currentImageIndex,
        boneName: state.boneName,
        coordinate: props.analysis?.analysis?.diskCoOrdinates,
        offsetPixel: { x: 0, y: 0 },
        offsetFractionY: state.offsetFractionY,
        offsetFractionX: state.offsetFractionX,
        imageLoaded: state.imageLoaded,
        totalSaggitalImage: props.sliceData?.reportImageData?.length || 0,
    };

    const onMouseEnter = e => {
        if (e === 'l3') {
            setLineStyle({ top: lineStyle.top, height: lineStyle.height, hovered: true });
        }
        if (e === 'l4') {
            setLineStyleL4({ top: lineStyleL4.top, height: lineStyleL4.height, hovered: true });
        }
        if (e === 'l5') {
            setLineStyleL5({ top: lineStyleL5.top, height: lineStyleL5.height, hovered: true });
        }
    };

    const onMouseLeave = e => {
        if (e === 'l3') {
            setLineStyle({ top: lineStyle.top, height: lineStyle.height, hovered: false });
        }
        if (e === 'l4') {
            setLineStyleL4({ top: lineStyleL4.top, height: lineStyleL4.height, hovered: false });
        }
        if (e === 'l5') {
            setLineStyleL5({ top: lineStyleL5.top, height: lineStyleL5.height, hovered: false });
        }
    };

    useEffect(() => {
        if (props.sliceData.reportImageData && !imageLoaded) {
            loadImage(currentIndex);
        }

        if (imageLoadedBool) {
            setBox()
        }

    });
    const loadImage = (id) => {
        // if (!currentIndex && currentIndex !== Math.floor(props.sliceData?.reportImageData?.length / 2)) {
        //     setCurrentIndex(Math.floor(props.sliceData?.reportImageData?.length / 2))
        // }

        if (currentIndex === undefined && props.sliceData?.reportImageData?.length) {
            setCurrentIndex(Math.floor(props.sliceData?.reportImageData?.length / 2))
        }
        if (ReportViewerElementDiv && viewStyle.width !== ReportViewerElementDiv.clientWidth) {
            setViewStyle({ width: ReportViewerElementDiv.clientWidth, height: ReportViewerElementDiv.clientWidth })
        }
        if ((!analysis || analysis !== props?.analysis?.analysis) && (props?.analysis?.analysis)) {
            setAnalysis(props?.analysis?.analysis);
        }
        if ((!diskWisePredictions.length || diskWisePredictions !== props?.analysis?.analysis?.diskWisePredictions) && (props?.analysis?.analysis?.diskWisePredictions)) {
            setDiskWisePredictions(props.analysis?.analysis?.diskWisePredictions);
        }
        if (props.sliceData.reportImageData) {

            cornerstoneTools.getModule("segmentation").configuration.segmentsPerLabelmap = 0
            cornerstoneTools.init({
                mouseEnabled: true,
                touchEnabled: true,
                globalToolSyncEnabled: true,
                showSVGCursors: true,
            });
            if (reportViewElement && state.sliceData[currentIndex]) {
                cornerstone.enable(reportViewElement);
                let idToFetchData = state.sliceData[currentIndex].fileIds[1];
                if (showOriginal) {
                    idToFetchData = state.sliceData[currentIndex].fileIds[0];
                }
                if (state.imageIds !== idToFetchData) {
                    state.imageIds = idToFetchData;
                    getImage(idToFetchData, (resp) => {
                        base64ToBuffer('data: image / png; base64,' + resp.fileData, (buf) => {
                            const imageId = cornerstoneFileImageLoader.fileManager.addBuffer(buf);
                            if (imageId) {
                                cornerstone.loadAndCacheImage(imageId).then((image) => {
                                    if (reportViewElement) {
                                        cornerstone.displayImage(reportViewElement, image);
                                        imageLoaded = true

                                    }
                                });
                            }
                        })
                    });
                    if (id === 0 && state.offsetFractionY === 0 && !imageLoaded && reportViewElement) {
                        reportViewElement.addEventListener('cornerstoneimagerendered', (e) => {
                            if (reportViewElement) {
                                const offsetx = reportViewElement.offsetLeft;
                                const offsety = reportViewElement.offsetTop;
                                const offsetxend = reportViewElement.offsetLeft + reportViewElement.offsetWidth;
                                const offsetyend = reportViewElement.offsetTop + reportViewElement.offsetHeight;
                                const positionStart = cornerstone.pageToPixel(reportViewElement, offsetx, offsety);
                                const positionEnd = cornerstone.pageToPixel(reportViewElement, offsetxend, offsetyend);

                                const equivalentPagex = offsetxend - offsetx;
                                const equivalentPagey = offsetyend - offsety;
                                const equivalentCanvasx = Math.abs(positionEnd.x) - Math.abs(positionStart.x);
                                const equivalentCanvasy = Math.abs(positionEnd.y) - Math.abs(positionStart.y);

                                state.offsetFractionY = equivalentPagey / equivalentCanvasy;
                                state.offsetFractionX = equivalentPagex / equivalentCanvasx;
                                const position00 = cornerstone.pageToPixel(reportViewElement, 0, 0);
                                const position100200 = cornerstone.pageToPixel(reportViewElement, 100, 200);
                                const position200300 = cornerstone.pageToPixel(reportViewElement, 200, 300);

                                const x1 = Math.abs(position00.x) - Math.abs(position100200.x);
                                const y1 = Math.abs(position00.y) - Math.abs(position100200.y);
                                const x2 = Math.abs(position100200.x) - Math.abs(position200300.x);
                                const y2 = Math.abs(position100200.y) - Math.abs(position200300.y);

                                const x3 = Math.abs(Math.abs(x2) - Math.abs(x1))
                                const y3 = Math.abs(Math.abs(y2) - Math.abs(y1))
                                state.offsetPixel = { x: x3, y: y3 }
                                state.imageLoaded = true
                                setImageLoadedBool(true)
                            }
                            // setBox();
                        });
                    }
                }
            }
        }
    }

    function setBox() {
        //For l3-l4
         if (state.coordinate) {
            for (let i = 2; i < 5; i++) {
                const height = mapCoordinate(state.coordinate[i].coOrdinates[2]) - mapCoordinate(state.coordinate[i].coOrdinates[0])
                const coord = state.coordinate[i].coOrdinates;
                if ((Math.trunc(state.offsetFractionY * 100) / 100) !== (Math.trunc(state.offsetFractionX * 100) / 100)) {
                    const calc = mapCoordinate(coord[0]) * state.offsetFractionY * 1.4;

                    if (i === 2 && lineStyle.top !== calc) {
                        setLineStyle({ top: calc, height: `${height * state.offsetFractionY * 1.4}px` });
                        // handleToggleClick();
                    } else if (i === 3 && lineStyleL4.top !== calc) {
                        setLineStyleL4({ top: calc, height: `${height * state.offsetFractionY * 1.4}px` });
                        // handleToggleClick();
                    }
                    else if (i === 4 && lineStyleL5.top !== calc) {
                        setLineStyleL5({ top: calc, height: `${height * state.offsetFractionY * 1.4}px` });
                        // handleToggleClick();
                    }
                }
                else {
                    const calc = mapCoordinate(coord[0]) * state.offsetFractionY;
                    if (i === 2 && lineStyle.top !== calc) {
                        setLineStyle({ top: calc, height: `${height * state.offsetFractionY}px` });
                        setImageLoadedBool(true);

                    } else if (i === 3 && lineStyleL4.top !== calc) {
                        setLineStyleL4({ top: calc, height: `${height * state.offsetFractionY}px` });
                        // handleToggleClick();
                    } else if (i === 4 && lineStyleL5.top !== calc) {
                        setLineStyleL5({ top: calc, height: `${height * state.offsetFractionY}px` });
                        // handleToggleClick();
                    }
                }
            }
        }
    }

    const handleChangeSlider = (event, newValue, activeThumb) => {
        if (currentIndex !== event.target.value - 1) {
            state.currentImageIndex = event.target.value - 1;
            setCurrentIndex(event.target.value - 1)
            loadImage(event.target.value - 1);
        }
    };



    function handleToggleClick() {
        setShowOriginal(!showOriginal);
    }
    return (
        <div >
            <div className="grid grid-cols-11 p-3 border border-blue-500 shdowsin rounded">
                <div className="col-span-4">
                    <div className="w-96 " ref={boxL3.ref} id={boxL3.id} >
                        {
                            diskWisePredictions.map((pred, index) => {
                                return index === 0 ?
                                    <p key={index} style={lineStyle.hovered ? { backgroundColor: "#031a4e", color: "#fff" } : {}}
                                        onMouseEnter={() => onMouseEnter('l3')} onMouseLeave={() => onMouseLeave('l3')}
                                        className="l3-div border border-green-400 bg-green-100 rounded p-4">
                                        {pred.reason}
                                    </p>
                                    :
                                    ''
                            })
                        }

                    </div>
                </div>
                <div className="col-span-3 canvas-report-outer justify-self-center ">

                    <div style={{ height: '400px', width: '400px' }} ref={(input) => {
                        ReportViewerElementDiv = input;
                    }}>

                        <div
                            className="viewportElement "
                            style={{
                                height: viewStyle.height,
                                width: viewStyle.width,
                                maxWidth: "100%",
                                maxHeight: "100%",
                                position: "relative",
                                color: "white"
                            }}
                            ref={(input) => {
                                reportViewElement = input;
                                loadImage(0)
                            }}
                        >
                            <canvas className="cornerstone-canvas" />


                            <div className="boxL3-parent "
                                onMouseEnter={() => onMouseEnter('l3')} onMouseLeave={() => onMouseLeave('l3')}
                                ref={boxL3Parent.ref} id={boxL3Parent.id}
                                style={lineStyle.hovered ? {
                                    border: "2px solid #79b0fc",
                                    top: lineStyle.top,
                                    height: lineStyle.height,
                                    position: "absolute",
                                    width: "90%",
                                    left: "5%"
                                } : {
                                    top: lineStyle.top,
                                    height: lineStyle.height,
                                    border: '1px solid #32ff2c',
                                    position: "absolute",
                                    width: "90%",
                                    left: "5%"
                                }} ></div>

                            <div className="boxL4-parent"
                                onMouseEnter={() => onMouseEnter('l4')} onMouseLeave={() => onMouseLeave('l4')}
                                ref={boxL4Parent.ref} id={boxL4Parent.id}
                                style={lineStyleL4.hovered ? {
                                    border: "2px solid #79b0fc",
                                    top: lineStyleL4.top,
                                    height: lineStyleL4.height,
                                    position: "absolute",
                                    width: "90%",
                                    left: "5%"
                                } :
                                    {
                                        top: lineStyleL4.top,
                                        height: lineStyleL4.height,
                                        border: '1px solid rgb(96,165,250)',
                                        position: "absolute",
                                        width: "90%",
                                        left: "5%"
                                    }}></div>

                            <div className="boxL5-parent "
                                style={lineStyleL5.hovered ? {
                                    border: "2px solid #79b0fc",
                                    top: lineStyleL5.top,
                                    height: lineStyleL5.height,
                                    position: "absolute",
                                    width: "90%",
                                    left: "5%"
                                }
                                    :
                                    {
                                        top: lineStyleL5.top,
                                        height: lineStyleL5.height,
                                        border: '1px solid rgb(34,211,238)',
                                        position: "absolute",
                                        width: "90%",
                                        left: "5%"
                                    }
                                }
                                onMouseEnter={() => onMouseEnter('l5')}
                                onMouseLeave={() => onMouseLeave('l5')}
                                ref={boxL5Parent.ref} id={boxL5Parent.id} ></div>
                        </div>
                    </div>
                    <div className="">
                        <div className="flex flex-col ">
                            <div className="py-2 text-center w-1/2 mx-auto ">
                                <Stack className=" relative" direction="row" spacing={1} alignItems="center">
                                    <Typography>ML Analysis</Typography>
                                    <AntSwitch checked={showOriginal}
                                        onChange={() =>
                                            handleToggleClick()
                                        }
                                        inputProps={{ 'aria-label': 'ant design' }} />
                                    <Typography>Original</Typography>
                                </Stack>
                            </div>
                        </div>
                    </div>
                    <div className="px-3">
                        {/* {props.sliceData?.reportImageData?.length && <PrettoSlider
                            valueLabelDisplay="auto"
                            aria-label="pretto slider"
                            defaultValue={props.sliceData?.reportImageData?.length/2}
                            step={1}
                            marks
                            min={1}
                            max={state.totalSaggitalImage}
                            onChange={handleChangeSlider}
                        />} */}
                        {props.sliceData?.reportImageData && <PrettoSlider
                            valueLabelDisplay="auto"
                            aria-label="pretto slider"
                            defaultValue={Math.floor(props.sliceData?.reportImageData?.length / 2)}
                            step={1}
                            marks
                            min={1}
                            max={state.totalSaggitalImage}
                            onChange={handleChangeSlider}
                        />}
                    </div>


                </div>
                <div className="col-span-4">
                    <div className="grid grid-cols-3">

                        <div className="col-span-3  mb-20 mr-2 " >

                            <div className="l4-div w-96 right-0 border border-blue-400 bg-blue-100 rounded float-right p-4"
                                style={lineStyleL4.hovered ? { backgroundColor: "#031a4e", color: "#fff" } : {}}
                                onMouseEnter={() => onMouseEnter('l4')} onMouseLeave={() => onMouseLeave('l4')}
                                ref={boxL4.ref} id={boxL4.id}>
                                {
                                    diskWisePredictions.map((pred, index) => {
                                        return index === 1 ?
                                            <p key={index}>
                                                {pred.reason}
                                            </p>
                                            :
                                            ''
                                    })
                                }
                            </div>

                        </div>
                        <div className="col-span-3  mt-20 mr-2">
                            <div className="l5-div w-96 right-0 border border-cyan-400 bg-cyan-100 rounded float-right p-4"
                                style={lineStyleL5.hovered ? { backgroundColor: "#031a4e", color: "#fff" } : {}}
                                onMouseEnter={() => onMouseEnter('l5')} onMouseLeave={() => onMouseLeave('l5')}
                                ref={boxL5.ref} id={boxL5.id}>
                                {
                                    diskWisePredictions.map((pred, index) => {
                                        return index === 2 ?
                                            <p key={index} >
                                                {pred.reason}
                                            </p>
                                            :
                                            ''
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Xarrow start={boxL3Parent.id} end={boxL3.ref} color={lineStyle.hovered ? '#618ef5' : 'green'} />
            <Xarrow start={boxL4Parent.id} end={boxL4.ref} color={lineStyleL4.hovered ? '#618ef5' : 'blue'} />
            <Xarrow start={boxL5Parent.id} end={boxL5.ref} color={lineStyleL5.hovered ? '#618ef5' : 'cyan'} />
        </div>
    );
}

export default withSnackbar(ReportView);